<template>
  <div class="father" style="min-width: 1314px">
    <div
      class="people"
      style="max-width: 300px !important; width: 300px !important"
    >
      <div>
        <wty-table
          ref="wtyTableRef"
          :who="who"
          :operate="'删除'"
          :wtycolumnList="tableClumn"
          :wtytbheigh="`${scroll_height}px`"
          :wtytbList="people_list"
          @deleteRow="deleteRow"
          @wtyTbreturn="wtyTbreturn"
          @updatePromiss="updatePromiss"
        ></wty-table>
      </div>
    </div>
    <div class="people" :style="`min-width:${scroll_height}`">
      <div class="people-title">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="手机号" v-if="who == 'peopleinfo'">
            <el-switch
              :disabled="accid_disabled"
              v-model="is_phone"
              active-color="#13ce66"
              inactive-color="#e5ebfe"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="is_phone ? '授权电话' : '授权id'">
            <el-input
              style="width: 150px"
              size="mini"
              :disabled="accid_disabled"
              v-model="permission_data.account_id"
              :placeholder="is_phone ? '授权电话' : '授权id'"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="who == 'permission'" label="用户组">
            <el-select
              size="mini"
              style="width: 150px !important"
              @visible-change="optionShow"
              placeholder="权限快捷选择"
              v-model="permission_data.group_no"
            >
              <el-option
                v-for="(item, index) in group_list"
                @click.native="getGroupPermission(item.group_id)"
                :key="index"
                :label="item.group_name"
                :value="item.group_no"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="who == 'peopleinfo' || who == 'shoppermission'"
            label="用户组"
          >
            <el-select
              size="mini"
              style="width: 150px !important"
              @visible-change="optionShow"
              placeholder="权限快捷选择"
              v-model="permission_data.group_id"
            >
              <el-option
                @click.native="getGroupPermission(item.group_id)"
                v-for="(item, index) in group_list"
                :key="index"
                :label="item.group_name"
                :value="item.group_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="permission-fa">
        <all-permission
          :treeData="treeData"
          ref="allPermissionRef"
          @checkedChange="checkedChange"
          @merchantSet="merchantSet"
          :height="`${scroll_height - 180}`"
        ></all-permission>
      </div>
      <div class="btn-fa">
        <el-button @click="addPermission">新增</el-button>
        <el-button
          type="primary"
          style="margin-left: 20px"
          @click="savePermission"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { deleteTabRepeat } from "@/js/public.js";
import allPermission from "@/components/allPermission";
import wtyTable from "@/components/wty-table";
import {
  setAccountPermissionASMerchant,
  delAccountPermissionASMerchant,
  queryAccountPermissionASMerchant,
  permissionListAccount,
} from "@/api/merchant.js";
import {
  getPermissList,
  getUsergroupList,
  getUserGroupPermission,
  setAccountPermission,
  delAccountPermission,
  baseinfoListAccount,
  getAccountPermission,
} from "@/api/service.js";
import {
  MusergroupQuery,
  getMerchantPermissList,
  MusergroupList,
  McreateUserGroup,
  MmodifyUserGroup,
  MsetUserGroupPermission,
  MdeleteUserGroupPermission,
  MdeleteUsrGroup,
  permissionMerchantSet, //店铺授权
  permissionMerchantDelete, //删除店铺权限
  permissionMerchantQuery, //查询店铺授权
  permissionMerchantList,
} from "@/api/merchant.js";

import { testR } from "../api/common";
export default {
  name: "wtyPermission",
  props: ["who", "perssionData", "tableList", "tableClumn"],
  data() {
    return {
      is_phone: false, //是否用手机号
      scroll_height: "", //计算的高度
      accid_disabled: false, //授权id是否允许输入
      table_show: "peoplepermisslist",
      row: -1,
      people_list: [],
      service_list: [],
      shop_list: [],
      treeData: [],
      treeData6: [],
      permission_data: {
        group_no: "",
        account_id: "",
        group_id: "",
      },
      group_data: {},
      group_list: [],
      checked_list: [],
      get_checkedlist: [],
    };
  },
  components: {
    allPermission,
    wtyTable,
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 180;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    /* availWH() {
      return this.$store.state.resolution.availWH;
    }, */
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
  },
  async created() {
    this.treeData = [];
    this.treeData6 = [];
    this.treeData = this.perssionData.t2;
    this.treeData6 = this.perssionData.t6;
    //获取左边店铺的所有成员
    this.table_show = false;
    this.people_list = [];
    //所有受过权限的用户
    this.people_list = this.tableList;
    this.table_show = true;

    // this.table_show = "peoplepermisslist";
    // console.log("treedata6-------------",this.treeData6);
  },

  methods: {
    wtyTbreturn(res) {
      console.log(res);
    },
    //获取用户组权限
    async optionShow(e) {
      if (e == true) {
        this.group_list = [];
        if (this.who == "permission") {
          this.group_list = await getUsergroupList();
        } else if (this.who == "peopleinfo" || this.who == "shoppermission") {
          this.group_list = await MusergroupList();
        }
      }
    },
    /* deleteRRRR(res){
      console.log("res---------",res);
    }, */
    /**
     * 删除行按钮返回
     * @param {Object} row 行数据
     */
    async deleteRow(row) {
      if (this.who == "permission") {
        //店铺删除权限
        const res = await getAccountPermission(row.account_id);
        if (this.testR(res)) {
          const del = res.data.resp_data;
          var list = [];
          for (let i = 0; i < del.length; i++) {
            list.push(del[i].permission_no);
          }
          const result = await delAccountPermission(row.account_id, list);
          if (!this.testR(result)) {
            return;
          }
          this.successMessage("保存成功");
          if (this.people_list.length == 1) {
            this.people_list = [];
          } else {
            this.people_list = deleteTabRepeat(
              row.account_id,
              this.people_list,
              "account_id"
            );
          }
          this.$refs.wtyTableRef.setpeopleList(this.people_list);
          this.addPermission();
        }
      } else if (this.who == "peopleinfo") {
        //TODO:2025-04-07
        //查询用户授权
        const res = await queryAccountPermissionASMerchant(row.account_id);

        if (testR(res)) {
          const del = res.data.resp_data;
          const list_res = await setAccountPermissionASMerchant(
            row.account_id,
            [],
            "account_id"
          );

          if (this.testR(list_res)) {
            this.successMessage("用户删除成功！");
            this.getAll();
          }

          return;

          var list = [];
          for (let i = 0; i < del.length; i++) {
            //删除用户授权
            list.push(
              delAccountPermissionASMerchant(
                row.account_id,
                del[i].permission_no
              )
            );
          }
          const [...result] = await Promise.all(list);
          if (!this.testR(result[0])) {
            this.successMessage("保存成功");
            return;
          }

          if (this.people_list.length == 1) {
            this.people_list = [];
          } else {
            this.people_list = deleteTabRepeat(
              row.account_id,
              this.people_list,
              "account_id"
            );
          }
        }
        //修改table组件里面的数据
      } else if (this.who == "shoppermission") {
        //TODO:2025-04-07
        //查询用户授权
        const mres = await permissionMerchantQuery(row.merchant_id);
        if (testR(mres)) {
          const del = mres.data.resp_data;
          var list = [];
          for (let i = 0; i < del.length; i++) {
            //删除用户授权
            list.push(
              permissionMerchantDelete(row.merchant_id, del[i].permission_no)
            );
          }
          const [...mresult] = await Promise.all(list);
          if (!this.testR(mresult[0])) {
            this.successMessage("保存成功");
            return;
          }

          if (this.shop_list.length == 1) {
            this.shop_list = [];
          } else {
            this.shop_list = deleteTabRepeat(
              row.merchant_id,
              this.shop_list,
              "merchant_id"
            );
          }
        }
        //修改table组件里面的数据
        this.$refs.wtyTableRef.setpeopleList(this.shop_list);
      }
      //调用新建方法
      this.addPermission();
    },
    // 修改功能 获取用户详细权限
    async updatePromiss(row, event, column) {
      /* console.log("我是谁2", this.who);

      switch (this.table_show) {
        case "peoplepermisslist":
          break;
        case "servicepermisslist":
          break;
        case "shoppermisslist":
          this.permission_data.account_id = row.merchant_id;
          break;
      } */
      if (this.who == "peopleinfo") {
        this.permission_data.account_id = row.account_id;
      } else if (this.who == "shoppermission") {
        this.permission_data.account_id = row.merchant_id;
      }
      this.accid_disabled = true;
      this.is_phone = false;
      if (this.who == "permission") {
        this.permission_data.account_id = row.account_id;
        const res = await getAccountPermission(row.account_id);
        this.changeCompPermiss(res.data.resp_data);
        this.get_checkedlist = [];
        for (let i = 0; i < res.data.resp_data.length; i++) {
          this.get_checkedlist.push(res.data.resp_data[i].permission_no);
        }
      } else if (this.who == "peopleinfo") {
        const res = await queryAccountPermissionASMerchant(row.account_id);
        this.changeCompPermiss(res.data.resp_data);
        this.get_checkedlist = [];
        for (let i = 0; i < res.data.resp_data.length; i++) {
          this.get_checkedlist.push(res.data.resp_data[i].permission_no);
        }
      } else if (this.who == "shoppermission") {
        //店铺授权的时候 查询店铺授权
        const result = await permissionMerchantQuery(row.merchant_id);
        //调用权限组件方法 修改权限
        this.changeCompPermiss(result.data.resp_data);
        //保存好线上权限
        this.get_checkedlist = [];
        for (let i = 0; i < result.data.resp_data.length; i++) {
          this.get_checkedlist.push(result.data.resp_data[i].permission_no);
        }
      }

      // permissionMerchantQuery
    },
    //新建
    addPermission() {
      // return;
      // this.$refs.peopleTableRef.setCurrentRow();
      switch (this.table_show) {
        case "peoplepermisslist":
          this.$refs.wtyTableRef.CancelHighLight();
          break;
        case "servicepermisslist":
          break;
        case "shoppermisslist":
          this.$refs.wtyTableRef.CancelHighLight();
          break;
      }
      this.permission_data.account_id = "";
      this.get_checkedlist = [];
      this.checked_list = [];
      this.changeCompPermiss([]);
      this.accid_disabled = false;
    },
    //获取所有用户
    async getAll() {
      //TODO:授权完成获取所有用户
      this.people_list = [];
      this.shop_list = [];
      if (this.who == "permission") {
        this.people_list = await baseinfoListAccount();
        this.$refs.wtyTableRef.setpeopleList(this.people_list);
      } else if (this.who == "peopleinfo") {
        this.people_list = await permissionListAccount();
        this.$refs.wtyTableRef.setpeopleList(this.people_list);
      } else if (this.who == "shoppermission") {
        this.shop_list = await permissionMerchantList();
        this.$refs.wtyTableRef.setpeopleList(this.shop_list);
      }
    },
    /**保存授权
     *
     *
     *
     */
    async savePermission() {

      if (this.checked_list.length == 0 && this.get_checkedlist.length == 0) {
        this.warnMessage("请选择权限");

        return;
      }
      /* if (
        localStorage.getItem("token_type") == "account" &&
        this.permission_data.account_id == localStorage.getItem("account_id")
      ) {
        this.warnMessage("不可以给自己的账号授权");
        this.addPermission();
        return;
      }
      // const setpermiss = setAccountPermission();
      if (this.permission_data.account_id == "") {
        this.warnMessage("请输入用户id！");
        return;
      } */
      //所有选中的权限
      var checked_list = [];
      this.treeData6.forEach((item, index, arr) => {
        if (this.checked_list.includes(item.label)) {
          checked_list.push(item.id);
        }
      });
      if (this.who == "peopleinfo") {
        const set_res = await setAccountPermissionASMerchant(
          this.permission_data.account_id,
          checked_list,
          this.is_phone==true?"mobile_no":"account_id"
        );
        if (this.testR(set_res)) {
          this.successMessage("权限修改成功！");
        }
        this.getAll();
        return;
      }

      // this.showdialog = value;
      //如果老的权限没有直接给用户授权
      if (this.get_checkedlist.length == 0) {
        try {
          let list = [];
          for (let i = 0; i < checked_list.length; i++) {
            list.push(checked_list[i]);
          }
          var list_res = null;
          if (this.who == "permission") {
            //服务商给用户授权
            list_res = await setAccountPermission(
              this.permission_data.account_id,
              list,
              this.is_phone ? "mobile_no" : "account_id"
            );
          } else if (this.who == "peopleinfo") {
            //店铺给用户授权
            list_res = await setAccountPermissionASMerchant(
              this.permission_data.account_id,
              list,
              this.is_phone ? "mobile_no" : "account_id"
            );
          } else if (this.who == "shoppermission") {
            //店铺给店铺授权

            list_res = await permissionMerchantSet(
              this.permission_data.account_id,
              list
            );
          }
          if (list_res != null) {
            if (this.testR(list_res)) {
              this.successMessage("用户授权成功！");
              this.getAll();
            }
          }
        } catch (e) {
          console.log("e", e);
        }
      } else {
        //TODO: 没有的权限
        //del 需要删除的权限 add 需要添加的权限
        var list = [];
        var dele = [];
        var set_res = {};
        var del_res = {};
        //如果老的里面有的新的里面没有的加入删除数组
        for (let i = 0; i < this.get_checkedlist.length; i++) {
          if (!checked_list.includes(this.get_checkedlist[i])) {
            dele.push(this.get_checkedlist[i]);
          }
        }
        if (dele.length > 0) {
          if (this.who == "permission") {
            del_res = await delAccountPermission(
              this.permission_data.account_id,
              dele
            );
          } else if (this.who == "peopleinfo") {
            del_res = await delAccountPermissionASMerchant(
              this.permission_data.account_id,
              dele
            );
          } else if (this.who == "shoppermission") {
            del_res = await permissionMerchantDelete(
              this.permission_data.account_id,
              dele
            );
          }
        }
        //如果新的里面有的老的里面没有的加入新增数组
        for (let j = 0; j < checked_list.length; j++) {
          if (!this.get_checkedlist.includes(checked_list[j])) {
            list.push(checked_list[j]);
          }
        }
        if (list.length > 0) {
          if (this.who == "permission") {
            set_res = await setAccountPermission(
              this.permission_data.account_id,
              list
            );
          } else if (this.who == "peopleinfo") {
            set_res = await setAccountPermissionASMerchant(
              this.permission_data.account_id,
              list
            );
          } else if (this.who == "shoppermission") {
            set_res = await permissionMerchantSet(
              this.permission_data.account_id,
              list
            );
          }
        }
        if (
          set_res.data &&
          this.testR(set_res) &&
          del_res.data &&
          this.testR(del_res)
        ) {
          this.successMessage("设置权限成功！");
        } else if (set_res.data && this.testR(set_res) && !del_res.data) {
          this.successMessage("设置权限成功！");
        } else if (del_res.data && this.testR(del_res) && !set_res.data) {
          this.successMessage("删除权限成功！");
        }
        if (this.who == "peopleinfo") {
          this.updatePromiss({
            account_id: this.permission_data.account_id,
          });
        } else if (this.who == "shoppermission") {
          this.updatePromiss({
            merchant_id: this.permission_data.account_id,
          });
        }

        return;
      }
    },
    getGroupBlur(e) {
      console.log("eeeeeeeeeeeeee", e);
    },
    async getGroupPermission(e) {
      if (this.who == "permission") {
        const res = await getUserGroupPermission(e);
        if (this.testR(res)) {
          this.changeCompPermiss(res.data.resp_data);
        }
      } else if (this.who == "peopleinfo" || this.who == "shoppermission") {
        const res = await MusergroupQuery(e);
        if (this.testR(res)) {
          this.changeCompPermiss(res.data.resp_data);
        }
      }
    },
    checkedChange(e) {
      this.checked_list = e;
    },
    /**
     * 修改组件中选中的权限
     */
    changeCompPermiss(list) {
      let get_checkedlist = [];
      this.checked_list = [];
      for (let i = 0; i < list.length; i++) {
        get_checkedlist.push(list[i].permission_no);
      }
      this.treeData6.forEach((item, index, array) => {
        if (get_checkedlist.includes(item.id)) {
          this.checked_list.push(item.label);
        }
      });
      // this.$refs.allPermissionRef.changeChecked([]);
      this.$refs.allPermissionRef.changeChecked(this.checked_list);
    },
    async merchantSet(e) {
      return;
      console.log(this.who);
      console.log("123", this.table_show);
      if (this.who != "merchant") {
        return;
      }
      switch (e) {
        case 0:
          this.table_show = "peoplepermisslist";
          // this.people_list =
          this.people_list = await permissionListAccount();
          this.$refs.wtyTableRef.setpeopleList(this.people_list);
          break;
        case 1:
          this.table_show = "servicepermisslist";
          break;
        case 2:
          this.table_show = "shoppermisslist";
          this.shop_list = await permissionMerchantList();
          this.$refs.wtyTableRef.setpeopleList(this.shop_list);
          break;
      }
      this.changeCompPermiss([]);
    },
  },
};
</script>

<style scoped lang="less">
.father {
  display: inline-block;
  // background-color: #e5ebfe;
}
.people {
  float: left;
  width: 50%;
  min-width: 600px;
  padding: 0 10px;
  height: 100%;
  margin-bottom: 20px;
  // background-color: rgb(234, 113, 113);
  // background-color: rgb(245, 166, 166);
  .btn-fa {
    width: 100%;
    display: flex;
    justify-content: left;
    .el-button {
      width: 30%;
    }
  }
  .people-title {
    width: 100%;
    height: 45px;
    background-color: #fff;
    // display: flex;
    justify-content: space-between;
    align-items: self-end;
    font-size: 16px;
    font-weight: 700;
    // border-bottom: 1px solid #ccc;
    // padding: 0 20px;
    margin-bottom: 10px;
    .add {
      width: 30px;
      height: 30px;
      // background-color: #eaeaea;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      font-weight: 700;
      margin: 10px;
    }
  }
}
</style>
